import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-lic_turismo',
  templateUrl: './lic_turismo.component.html',
  styleUrls: ['./lic_turismo.component.css']
})
export class Lic_turismoComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
